/**
 * @desc 驳回重新编辑
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ResubmitRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/reject/reEdit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
